import { render, staticRenderFns } from "./ProjectSelector.vue?vue&type=template&id=311172b4"
import script from "./ProjectSelector.vue?vue&type=script&lang=ts"
export * from "./ProjectSelector.vue?vue&type=script&lang=ts"
import style0 from "./ProjectSelector.vue?vue&type=style&index=0&id=311172b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports